import type { Chord } from '@/types/chord';
import type { Move, MoveContext, MoveResult } from '../types';

/**
 * delay the arrival — deceptive motion (V -> vi instead of V -> I).
 * v1 is major-mode only, matching the spec's literal "is I" (capital I is
 * the major tonic; a minor-mode deceptive cadence — V -> VI — is a
 * different scale-degree relationship and out of scope here).
 */
export const delayTheArrival: Move = {
  id: 'delay-the-arrival',
  name: 'delay the arrival',
  theory: 'deceptive motion',

  applicable(ctx: MoveContext): boolean {
    const chord = ctx.chords[ctx.index];
    const prev = ctx.chords[ctx.index - 1];
    if (!chord || !prev || ctx.mode !== 'major') return false;
    if (chord.scaleDegree !== 1 || chord.isChromatic) return false;
    return prev.scaleDegree === 5 && (prev.quality === 'major' || prev.quality === 'dom7');
  },

  apply(ctx: MoveContext): MoveResult {
    const chord = ctx.chords[ctx.index];
    const changed: Chord = {
      ...chord,
      scaleDegree: 6,
      quality: 'minor',
      isChromatic: false,
      chromaticType: undefined,
      key: ctx.key,
      mode: ctx.mode,
    };
    const chords: Chord[] = ctx.chords.map((c, i) => (i === ctx.index ? changed : c));

    return {
      chords,
      changedIds: [changed.id],
      explanation: 'the ear expected home — landed on its shadow instead.',
      theoryLabel: 'deceptive cadence · V → vi',
    };
  },
};
